import React from 'react';

const LINKS = [
  {
    label: 'Book a Meeting',
    value: 'cal.com/satyarthap',
    href: 'https://cal.com/satyarthap/availability',
    icon: 'Cal',
  },
  {
    label: 'Email',
    value: 'psatyarthaprakash@gmail.com',
    href: 'mailto:psatyarthaprakash@gmail.com',
    icon: '@',
  },
  {
    label: 'LinkedIn',
    value: 'linkedin.com/in/satyarthap',
    href: 'https://www.linkedin.com/in/satyarthap/',
    icon: 'in',
  },
];

function ContactMe() {
  return (
    <footer className="contact-me">
      <div className="contact-availability">
        <span className="availability-indicator" />
        Open to new opportunities in Austin, TX
      </div>
      <h2 className="contact-title">Let's Connect</h2>
      <p className="contact-subtitle">
        I'm always open to discussing AI/ML roles, collaborations, or just a great conversation.
      </p>
      <div className="contact-links">
        {LINKS.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target={l.href.startsWith('mailto') ? undefined : '_blank'}
            rel="noopener noreferrer"
            className="contact-card"
          >
            <div className="contact-icon-label">{l.icon}</div>
            <div>
              <div className="contact-card-label">{l.label}</div>
              <div className="contact-card-value">{l.value}</div>
            </div>
          </a>
        ))}
      </div>
    </footer>
  );
}

export default ContactMe;
